
import Vue from 'vue'
import { fetchCategoryProductList } from '@/categories/helper'
import ProductSectionProducts from '@/categories/components/ProductSectionProducts.vue'
import { ProductType } from '@/types'
import { SYSTEM_ERROR } from '@/common/constants'
export default Vue.extend({
  components: {
    ProductSectionProducts
  },
  props: {
    categoryId: {
      type: Number,
      required: true
    }
  },
  data(): {
    productList: ProductType[],
    offset: number,
    limit: number,
    totalItems: number,
    isLoading: boolean
  } {
    return {
      productList: [],
      offset: 0,
      limit: 40,
      totalItems: 0,
      isLoading: false
    }
  },
  created(): void {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      try {
        this.isLoading = true
        const { data } = await fetchCategoryProductList(this.categoryId, this.offset, this.limit).catch(() => alert(SYSTEM_ERROR.UNKNOWN))
        if (data) {
          this.productList.push(...data.items)
          this.totalItems = data.totalItemsCount
        }
      } finally {
        this.isLoading = false
      }
    },
    loadMore() {
      this.offset += this.limit
      this.fetchData()
    }
  }
})
